import React from "react";
import {
  ChecklistFormWrapper,
  ChecklistFormSection,
  ChecklistFormGrade,
  ChecklistFormOption,
} from "./_.styled";
import FormField from "./../ChecklistFormField";

const ChecklistForm = () => (
  <ChecklistFormWrapper data-testid="checklist-form" data-auto="checklistform">
    <ChecklistFormSection data-auto="checklistform-section">
      <FormField name="EVALUATOR" />
      <FormField name="EXAMINEE" />
    </ChecklistFormSection>
    <ChecklistFormSection data-auto="checklistform-section">
      <FormField name="SIGNATURE" />
      <FormField name="SIGNATURE" />
    </ChecklistFormSection>
    <ChecklistFormSection data-auto="checklistform-section">
      <FormField name="DATE" />
      <ChecklistFormGrade>
        <ChecklistFormOption data-auto="checklistform-option">
          PASS
        </ChecklistFormOption>
        <ChecklistFormOption data-auto="checklistform-option">
          FAIL
        </ChecklistFormOption>
      </ChecklistFormGrade>
    </ChecklistFormSection>
  </ChecklistFormWrapper>
);

ChecklistForm.displayName = "ChecklistForm";

export default ChecklistForm;
